import axios from 'axios';

const baseURL =
  process.env.REACT_APP_API_URL ??
  window.__ENV__?.API_URL ??
  'http://localhost:8080/api';

const axiosClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// redirect SOLO per token realmente scaduto
const redirectToTokenExpired = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('profile');
  window.location.href = '/token-expired';
};

// REQUEST: aggiunge JWT
axiosClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  console.log("axiosclient token",token);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// RESPONSE: gestione errori
axiosClient.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      // errore di rete
      return Promise.reject(error);
    }

    const status = error.response.status;

    // 🔴 SOLO 401 = token non valido
    if (status === 401) {
      console.warn('JWT expired or invalid');
      redirectToTokenExpired();
      return;
    }

    // 🟠 403 = errore di autorizzazione (NON logout)
    if (status === 403) {
      console.warn('Access denied');
      return Promise.reject(error);
    }

    // 🟡 errori di business
    if ([400, 404, 409, 422].includes(status)) {
      return Promise.reject(error);
    }

    // 🔵 500 = errore backend (mostrare messaggio)
    if (status === 500) {
      console.error('Backend error:', error.response.data);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axiosClient;